import catalogue from "./standards.json";

/**
 * The Common Core codes the worksheet pages cite, and one line of text for
 * each (ADR 0065 §2). Pages list codes only; the text is written once here so
 * two pages citing the same standard cannot describe it differently.
 *
 * JSON rather than TypeScript because scripts/prerender.js is plain Node and
 * reads it too, for the static page and its structured data.
 */
export const STANDARDS: Record<string, string> = catalogue;

/** The line of text for a code, or the code itself if the catalogue lacks it. */
export function standardText(code: string): string {
    return STANDARDS[code] ?? code;
}
